import React from 'react';
import { FxInfoTooltip } from '../FxInfoTooltip';
import { ReactComponent as AlertWarningTriangleIcon } from '../../../assets/svg/alertWarningTriangle.svg';
import {
    getNotificationBannerMessage,
    getNotificationBannerPopupMessage,
    getNotificationBannerTitle,
} from './maintenanceBannerUtils';

/**
 * PM-configurable notification banner (maintenance / portal announcements).
 * Title, body, and tooltip copy come from processing settings via maintenanceBannerUtils.
 */
export const MaintenanceBanner: React.FC = () => (
    <div className="fx-maintenance-banner">
        <div className="fx-maintenance-banner-heading">
            <AlertWarningTriangleIcon className="fx-maintenance-banner-icon" />
            {getNotificationBannerTitle()}
        </div>
        <div className="fx-maintenance-banner-body">
            <span className="fx-maintenance-banner-message">
                {getNotificationBannerMessage()}
            </span>
            {/* Hide Learn More when POPUP_MESSAGE is empty — avoids an empty tooltip */}
            {getNotificationBannerPopupMessage().trim() && (
                <FxInfoTooltip
                    arrow
                    placement="bottom"
                    className="fx-maintenance-banner-tooltip"
                    title={getNotificationBannerPopupMessage()}
                >
                    <button type="button" className="fx-maintenance-banner-learn-more">
                        Learn More &gt;
                    </button>
                </FxInfoTooltip>
            )}
        </div>
    </div>
);
